export default __webpack_public_path__ + "static/media/Ainol Novo 9 Spark.9fc3f8e9.png";